
import { Card, Flex, Row, Col, Divider } from 'antd';




export const Error = (props) => {


    return (

        <div className="App">
    
          <Flex className='Main' justify='center' align='center'>
            <Card className='Login'
              bordered={false}
              style={{ width: 400 }}
            >
              <img alt="interlogica" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
              Metahuman Info
              <br></br>
              <br></br>
              You are not authorized to access
            </Card>
          </Flex>
    
        </div>
    
      );



}